import type { WsInplantFilter } from "../../../../../../api/wsInplants";
import {
    defineFilterConfig,
    filterDateIntervalFromNotAfterTo,
    filterDateIntervalToNotBeforeFrom,
    filterFieldAdapters,
} from "@src/components/business-form";

/** Значения filter-формы списка ВЗН УП. */
export interface WsInplantsFilterFormValues {
    num: string;
    senderCode: number | null;
    receiverCode: number | null;
    leaveMoveDateFrom: string | null;
    leaveMoveDateTo: string | null;
    arrivalMoveDateFrom: string | null;
    arrivalMoveDateTo: string | null;
}

export const wsInplantsFilterFormConfig = defineFilterConfig<WsInplantsFilterFormValues, WsInplantFilter>({
    fields: {
        num: {
            type: "string",
            label: "Номер ВЗН",
            map: {
                from: (domain) => domain.Num ?? "",
                to: (value) => {
                    const trimmed = value.trim();
                    return trimmed === "" ? { Num: undefined } : { Num: trimmed };
                },
            },
        },
        senderCode: {
            type: "number",
            nullable: true,
            label: "Отправитель",
            map: filterFieldAdapters.singleCodeArray("SenderCodes"),
        },
        receiverCode: {
            type: "number",
            nullable: true,
            label: "Получатель",
            map: filterFieldAdapters.singleCodeArray("ReceiverCodes"),
        },
        leaveMoveDateFrom: {
            type: "date",
            nullable: true,
            label: "Дата выдачи (с)",
            map: filterFieldAdapters.dateIntervalEnd("LeaveMoveDate", "from", "leaveMoveDateTo"),
            validation: {
                validate: (value, formValues) => filterDateIntervalFromNotAfterTo(value, formValues.leaveMoveDateTo),
                deps: ["leaveMoveDateTo"],
            },
        },
        leaveMoveDateTo: {
            type: "date",
            nullable: true,
            label: "Дата выдачи (по)",
            map: filterFieldAdapters.dateIntervalEnd("LeaveMoveDate", "to", "leaveMoveDateFrom"),
            validation: {
                validate: (value, formValues) => filterDateIntervalToNotBeforeFrom(value, formValues.leaveMoveDateFrom),
                deps: ["leaveMoveDateFrom"],
            },
        },
        arrivalMoveDateFrom: {
            type: "date",
            nullable: true,
            label: "Дата принятия (с)",
            map: filterFieldAdapters.dateIntervalEnd("ArrivalMoveDate", "from", "arrivalMoveDateTo"),
            validation: {
                validate: (value, formValues) => filterDateIntervalFromNotAfterTo(value, formValues.arrivalMoveDateTo),
                deps: ["arrivalMoveDateTo"],
            },
        },
        arrivalMoveDateTo: {
            type: "date",
            nullable: true,
            label: "Дата принятия (по)",
            map: filterFieldAdapters.dateIntervalEnd("ArrivalMoveDate", "to", "arrivalMoveDateFrom"),
            validation: {
                validate: (value, formValues) => filterDateIntervalToNotBeforeFrom(value, formValues.arrivalMoveDateFrom),
                deps: ["arrivalMoveDateFrom"],
            },
        },
    },
});
